export const ERROR_MSGS = {
    EXISTING_ACC: "You already have a Koko account.",
    NONEXISTING_ACC: "Oops! We’re sorry, this Koko account doesn’t exist.",
    UNABLE_RETRIEVE: "Oops! We’re unable to retrieve your Daraz phone number. Try downloading the Koko app.",
    INCORRECT_PASSWORD: "Please enter a valid PIN / Password",
    UNMATCHED_PINCODE: "PIN Code doesn't match",
    INCORRECT_PINCODE: "Incorrect pincode",
    EXISTING_PAYMENT_METHOD: "Uh Oh! This card already exists in our system. Try adding a new card",
    INVALID_PAYMENT_MEHTOD: "Card declined. Oops! Please try again with a valid card or contact your bank.",
    ACC_LOCK: "User Account Locked!",
    INVALID_OTP: "Invalid Otp",
    EXPIRED_OTP: "Otp Expired",
    EXISTING_EMAIL: "Email Already Exists",
    EXISTING_NIC: "NIC Already Exists",
    INVALID_NIC: "Invalid NIC"
};